import { useEffect, useState } from "react";
import { getNodeSetNodes, getNodeSets } from "../api/quontxApi";
import SidePanel from "../components/SidePanel";
import { getPaginatedData } from "../utils";

const SourceTreePage = () => {
  const [collapsed, setCollapsed] = useState(true);
  const [displayData, setDisplayData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [searchString, setSearchString] = useState("");

  const [nodeSets, setNodeSets] = useState([]);
  const [filteredNodeSets, setFilteredNodeSets] = useState([]);
  const [nodesMap, setNodesMap] = useState({});

  const loadNodeSets = async () => {
    const nodeSets = await getPaginatedData(getNodeSets, {
      itemsPerPage: 100,
    });

    const cleanedNodeSets = nodeSets.data
      .map((nodeSet) => {
        return {
          ...nodeSet,
          opened: false,
          loading: false,
        };
      })
      .sort((a, b) => {
        if (a.description > b.description) return 1;
        if (a.description < b.description) return -1;
        return 0;
      });

    setNodeSets(cleanedNodeSets);
    setFilteredNodeSets(cleanedNodeSets);
    setDisplayData(cleanedNodeSets);
  };

  const loadNodes = async (nodeSetId) => {
    // Open the leafs of the clicked parent
    const parentNodeSet = nodeSets.find(
      (nodeSet) => nodeSet.uuid === nodeSetId
    );
    parentNodeSet.opened = !parentNodeSet.opened;
    parentNodeSet.loading = true;
    const parentIdx = nodeSets.indexOf(parentNodeSet);
    parentNodeSet[parentIdx] = parentNodeSet;
    setNodeSets([...nodeSets]);

    // Load node set leafs (nodes)
    let nodes = [];
    if (!nodesMap[nodeSetId]) {
      const nodesRes = await getPaginatedData(getNodeSetNodes, {
        itemsPerPage: 100,
        nodeSetId,
      });
      nodes = nodesRes.data.sort((a, b) => {
        if (a.name > b.name) return 1;
        if (a.name < b.name) return -1;
        return 0;
      });
    } else {
      nodes = nodesMap[nodeSetId];
    }

    parentNodeSet.loading = false;
    nodesMap[nodeSetId] = nodes;
    setNodesMap({ ...nodesMap });
  };

  useEffect(() => {
    setFilteredNodeSets(
      nodeSets.filter((nodeSet) =>
        nodeSet.description.toLowerCase().includes(searchString.toLowerCase())
      )
    );
    if (
      searchString === "" ||
      searchString === undefined ||
      searchString === null
    ) {
      setFilteredNodeSets(nodeSets);
    }
  }, [searchString, nodeSets]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await loadNodeSets();
      setIsLoading(false);
    })();
  }, []);

  return (
    <div className="flex relative">
      <SidePanel
        collapseCallback={() => setCollapsed(!collapsed)}
        collapsed={collapsed}
        data={displayData}
      />
      <div className="w-full flex flex-col items-center content-center">
        <div className="w-full">
          <div className="mb-8 mt-8 w-[50%] ml-auto mr-auto">
            <div className="flex-1 w-full">
              <label
                htmlFor="src_uuid_filter"
                className="text-sm font-medium text-qtx-gray"
              >
                Search
              </label>
              <input
                id="source_name_filter"
                type="text"
                value={searchString}
                onChange={(e) => setSearchString(e.target.value)}
                placeholder="Filter tree by name"
                className="w-full mt-1 bg-qtx-dark border border-qtx-gray rounded py-2 px-3 text-white leading-tight focus:outline-none focus:ring-2 focus:ring-qtx-blue"
              />
            </div>
          </div>
          <div className="ml-auto mr-auto w-[50%] pt-8 pb-8 overflow-y-auto custom-scrollbar h-[70vh]">
            {filteredNodeSets.length === 0 && isLoading && (
              <p>Loading data...</p>
            )}
            {filteredNodeSets.length === 0 && !isLoading && (
              <p>No search results</p>
            )}
            {filteredNodeSets.length > 0 && (
              <ul>
                {filteredNodeSets.map((nodeSet) => {
                  return (
                    <li key={nodeSet.uuid}>
                      <button
                        className="text-left font-bold"
                        onClick={() => loadNodes(nodeSet.uuid)}
                      >
                        {!nodeSet.opened && <span className="mr-4">+</span>}
                        {nodeSet.opened && <span className="mr-4">-</span>}
                        {nodeSet.description}
                      </button>
                      {nodeSet.opened && (
                        <div className="ml-8">
                          {nodeSet.loading && <p>Loading...</p>}
                          <ul>
                            {nodesMap[nodeSet.uuid] &&
                              nodesMap[nodeSet.uuid].map((node) => {
                                return (
                                  <a
                                    className="underline decoration-solid"
                                    key={node.uuid}
                                    href={node.url}
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    <li>{node.name}</li>
                                  </a>
                                );
                              })}
                          </ul>
                        </div>
                      )}
                    </li>
                  );
                })}
              </ul>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SourceTreePage;
